import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\New folder (2)\\www\\www\\www\\app\\(general)\\blog\\[slug]\\ClientComponent.tsx");
